import * as React from "react";
const SvgArrowLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="m9.55 12 7.35 7.35q.374.375.363.875a1.25 1.25 0 0 1-.388.875 1.2 1.2 0 0 1-.875.375 1.2 1.2 0 0 1-.875-.375l-7.7-7.675q-.3-.3-.45-.675t-.15-.75.15-.75.45-.675l7.7-7.7q.375-.374.887-.363.513.013.888.388t.375.875a1.2 1.2 0 0 1-.375.875z"
    />
  </svg>
);
export default SvgArrowLeft;
